import routes from '@/routes';

/**
 * 扁平化前端路由配置，获取所有真实存在的路由路径
 * 只收集有 component 的路由（真实页面），排除 redirect 和 wrapper
 */
export const getFlattenRoutePaths = (routeList: any[]): Set<string> => {
  const paths = new Set<string>();

  const traverse = (routes: any[]) => {
    routes.forEach(route => {
      // 只收集有 component 的路由（真实页面），排除 redirect 和 wrapper
      if (route.path && route.component && !route.redirect) {
        paths.add(route.path);
      }
      // 递归处理子路由
      if (route.routes && route.routes.length > 0) {
        traverse(route.routes);
      }
    });
  };

  traverse(routeList);
  return paths;
};

/**
 * 前端真实存在的路由路径集合（缓存）
 */
export const validRoutePaths = getFlattenRoutePaths(routes);
